import jQuery from 'jquery/dist/jquery'
window.jQuery = jQuery

import '../scss/theme.scss';

import 'slick-carousel/slick/slick'
import 'slick-carousel/slick/slick.scss'
import 'slick-carousel/slick/slick-theme.scss'

import lightbox from 'lightbox2/src/js/lightbox.js'
import 'lightbox2/src/css/lightbox.css'

import '../acf-blocks/news-list/news-list.ts'

import '../ext/vanilla-js-carousel-master/carousel.css'
import Carousel from '../ext/vanilla-js-carousel-master/carousel.js'

window.addEventListener('load', () => {
    document.querySelector('#toggle-searchbar')
        .addEventListener('click', () => {
            if ('#search' === location.hash) {
                location.hash = ''
            } else {
                location.hash = 'search'
            }
        })

    jQuery('.slider').slick({
        arrows: false,
        autoplay: true,
        dots: true
    });

    document.querySelectorAll('.gallery').forEach(container => {
        const galleryControlsContainer = container.querySelector('.gallery-controls');
        const galleryItems = container.querySelectorAll('.gallery-item');
        const galleryControls = [{ action: 'previous', label: 'Zurück' }, { action: 'next', label: 'Weiter' }];

        const carousel = new Carousel(container, galleryItems, galleryControlsContainer, galleryControls);

        if (container.hasAttribute('data-autoplay')) {
            carousel.enableAutoPlay(parseInt(container.getAttribute('data-autoplay')))
        }
        carousel.setControls();
        carousel.useControls();
    })

    lightbox.option({
        albumLabel: 'Bild %1 von %2'
    })
})
